import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const Breadcrumb = () => {
  const { t } = useTranslation('preInvoicesModule');

  const breadcrumbs = useMemo(
    () => [
      { label: t('breadcrumb.invoices', 'Facturación') },
      {
        label: <span className="text-title">{t('breadcrumb.preinvoices', 'Prefacturas')}</span>,
      },
    ],
    [t],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
